export default class Element {
    constructor() {
        this.element = document.createElement("div");
    }

    addToParent(parent) {
        this.parent = parent;
        this.parent.appendChild(this.element);
    }
    destroy () {
        this.element.remove();
    }
}


// WEBPACK FOOTER //
// ./src/Utils/Element.js